module.exports = __webpack_public_path__ + "static/img/bg.b55e2f14.png";